import { Typography, Paper } from '@mui/material';
import { Box, Grid } from '@mui/system';
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/styles.min.css';
import { HowToStep } from '../Constants';
import { getImageSrc } from '../../../utils/getImageSrc';
import HowToStepTitleHelper from './HowToStepTileHelper';

type Props = {
  activeStep: number;
  howToSteps: Array<HowToStep>;
};

const LargeDeviceSteps = ({ activeStep, howToSteps }: Props) => {
  return (
    <Box width={'100%'} height={'100%'}>
      <Typography variant="h6" gutterBottom>
        <HowToStepTitleHelper howToStep={howToSteps[activeStep]} />
      </Typography>
      <Box component="ol" paddingLeft={3} marginBottom={1}>
        {howToSteps[activeStep].body.map((line, index) => (
          <li key={index}>
            <Typography variant="body1">{line}</Typography>
          </li>
        ))}
      </Box>
      <Grid
        container
        spacing={1}
        justifyContent={'center'}
        alignItems={'center'}
      >
        {howToSteps[activeStep].images.map((image) => (
          <Grid
            size={howToSteps[activeStep].images.length > 1 ? 6 : 12}
            key={image.filename}
          >
            <Paper
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === 'light'
                    ? theme.palette.grey[200]
                    : theme.palette.grey[600],
                padding: 1,
                borderColor: (theme) =>
                  theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[800],
              }}
            >
              <InnerImageZoom
                src={getImageSrc(
                  image.filename,
                  image.folderName,
                  false,
                  image.url,
                )}
                imgAttributes={{ alt: image.alt }}
                hideCloseButton
                hideHint
                width={1920}
                height={1080}
              />
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LargeDeviceSteps;
